import { useFormEdit } from "../../util/hooks/useFormEdit";
import { CustomButton } from "../../components";
import CustomInput from "../../components/CustomInput";
import SubHeadings from "../../components/SubHeadings";
import { Staff } from "../../types/staff";

interface PersonalInformationProps {
  staff?: Staff;
  onChange: (data: Partial<Staff>) => void;
}

export default function FinancialInfo({
  staff,
  onChange,
}: PersonalInformationProps) {
  const { isEditing } = useFormEdit<Staff>({} as Staff);

  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;
    onChange({ [name]: value });
  };
  
  return (
    <div className="px-4 md:px-9 gap-9">
      <div className="flex flex-col gap-7 w-full py-7">
        <SubHeadings text="Financial Details" />
        <form className="grid gap-7">
          <div className="grid gap-7">
            <div className="grid md:grid-cols-3 gap-7">
              <CustomInput
                name="initialSalary"
                label="Initial Salary"
                type="text"
                placeholder="-----"
                readOnly={!isEditing}
                value={staff?.initialSalary?.toString() ?? ""}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
              <CustomInput
                name="currentSalary"
                label="Current Salary"
                type="text"
                placeholder="-----"
                readOnly={!isEditing}
                value={staff?.currentSalary?.toString() ?? ""}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
              <CustomInput
                name="accountNumber"
                label="Account Number"
                type="text"
                placeholder="Enter account number"
                readOnly={!isEditing}
                value={staff?.accountNumber || ""}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
            </div>

            <div className="grid md:grid-cols-2 gap-7">
              <CustomInput
                name="accountHolderName"
                label="Account Holder's Name"
                type="text"
                placeholder="Enter account holder's name"
                readOnly={!isEditing}
                value={staff?.accountHolderName || ""}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
              <CustomInput
                name="bankName"
                label="Bank Name"
                type="text"
                placeholder="Enter bank name"
                readOnly={!isEditing}
                value={staff?.bankName || ""}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
              <CustomInput
                name="ifscCode"
                label="IFSC Code"
                type="text"
                placeholder="Enter IFSC code"
                readOnly={!isEditing}
                value={staff?.ifscCode || ""}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
              <CustomInput
                name="branchName"
                label="Branch Name"
                type="text"
                placeholder="Enter branch name"
                readOnly={!isEditing}
                value={staff?.branchName || ""}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
              <CustomInput
                name="panNumber"
                label="PAN Number"
                type="text"
                placeholder="Enter PAN number"
                readOnly={!isEditing}
                value={staff?.panNumber || ""}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
              <CustomInput
                name="uanNumber"
                label="UAN Number"
                type="text"
                placeholder="Enter UAN number"
                readOnly={!isEditing}
                value={staff?.uanNumber || ""}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
            </div>
          </div>

          {/* <div className="flex justify-end items-end relative group">
                    <CustomButton
                      color="bg-primary-500"
                      text="Submit"
                      disabled={!hasUnsavedChanges || !isEditing}
                    />
        
                    {!hasUnsavedChanges && (
                      <span className="absolute bottom-full mb-2 right-0 bg-neutral-300 text-white text-xs font-medium px-3 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                        {isEditing
                          ? "No changes yet — fill out or edit the form to get started"
                          : "Enable edit mode to make changes"}
                      </span>
                    )}
                  </div> */}
        </form>
      </div>
    </div>
  );
}
